import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "@heroui/react";

/**
 * Legacy rental component - now redirects to the new rental statistics page
 * This component has been split into multiple focused pages for better performance and maintainability
 */
const Rental = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to the rental statistics page by default
    navigate("/rental/statistics", { replace: true });
  }, [navigate]);

  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner
        size="lg"
        color="primary"
        label="Doorverwijzen naar verhuur statistieken..."
        classNames={{
          wrapper: "flex flex-col items-center gap-4",
          circle1: "border-b-moss-primary",
          label: "text-moss-primary font-medium"
        }}
      />
    </div>
  );
};

export default Rental;
